import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import BannerVehiculos from "../vehiculos/BannerVehiculos";
import CatalogoVehiculos from "../vehiculos/CatalogoVehiculos";
const Footer = lazy(() => import('../footer/Footer'));
function Vehiculos(props) {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Conoce los mejores modelos disponibles en Ecuador, Grand i10, Verna, Accent, Ioniq, Veloster, Venue, Creta, Tucson, Santa Fe, H1. Tenemos uno para ti"
        />
        <meta
          name="keywords"
          content="Hyundai, Grand i10, Accent, Ioniq, Creta, Tucson, Santa Fe"
        />
        <title>Vehículos y Modelos Hyundai</title>
      </Helmet>
      <Menu />
      <BannerVehiculos />
      <CatalogoVehiculos datos={props} />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Vehiculos;